import React, { Component, useState } from 'react'
import Modal from 'react-bootstrap/Modal';

const LockinpriodPopup = (props) => {
return (
  <Modal {...props} className="lockinpriod-popup" aria-labelledby="contained-modal-title-vcenter" centered>
    <section className='lockinpriod-modal'>
      <a onClick={props.lockPopup_closeBtn} className='close-icon' href='javascript:;' title='Close'>&nbsp;</a>
      <Modal.Body>
        <section className='content'>
          <h1>LOCK-IN PERIOD</h1>
          <p>Before you sign up, please note that our subscription program has a lock-in period of 4 months. This means that you will not be able to cancel your subscription during the first 4 months.</p>
        </section>
        <aside className="cmx-flex-btn-group text-start">
            <a onClick={props.lockPopup_closeBtn} className="flex-btn" href="javascript:;" title="CANCEL"><span>Cancel</span></a>
            <a onClick={props.selectPlan} className="flex-btn" href="javascript:;" title="I AGREE"><span>i agree</span></a>
          </aside>
      </Modal.Body>
    </section>
  </Modal>
)}
export default LockinpriodPopup;